const expiredPayoutTypes = {
  SET_EXPIRED_PAYOUTS: "SET_EXPIRED_PAYOUTS",
  SET_LOADING: "SET_LOADING",
};

export default expiredPayoutTypes;
